import { createContext, useContext } from "react";

import { type DefaultableCardType, type PaymentProvider } from "@/api-v3";

import type { ExtendedPaymentMethod } from "../hooks/use-available-payment-methods";

interface PaymentMethodFormsContextType {
  formData: Record<string, Record<string, string>>;
  paymentMethod?: ExtendedPaymentMethod;
  updateFormData: (formName: string, newData: Record<string, string>) => void;
  submitFormData: () => Promise<void>;
  isSubmitting: boolean;
  getAllFormData: () => Record<string, string>;
  setDefaultPaymentMethod: (
    paymentMethodType: DefaultableCardType,
    provider: PaymentProvider,
    onSuccess?: () => void
  ) => void;
  isSettingDefaultPaymentMethod: boolean;
  /** Ids of the method's `legal_documents` the participant has ticked. */
  acknowledgedLegalDocumentIds: string[];
  toggleLegalDocumentAcknowledged: (
    documentId: string,
    acknowledged: boolean
  ) => void;
  /** True when the method has no documents or every one is acknowledged. */
  allLegalDocumentsAcknowledged: boolean;
  completePaymentMethodChange: () => void;
}

export const PaymentMethodFormsContext = createContext<
  PaymentMethodFormsContextType | undefined
>(undefined);

export const usePaymentMethodForms = () => {
  const context = useContext(PaymentMethodFormsContext);
  if (!context) {
    throw new Error(
      "usePaymentMethodForms must be used within a PaymentMethodFormsProvider"
    );
  }
  return context;
};
